/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from "react";
import styled from "@emotion/styled";
import { colors } from "@utils/ui_palette";
import { IModule } from "@pages/AssessmentDetail";
import InterviewModal from "../modal/InterviewModal";

interface IPatterns {
  type: string;
  item: IModule;
  anwserCallback: (item: IModule, type: string) => Promise<void>;
}

function InterView({ type, item, anwserCallback }: IPatterns) {
  const [modal, setModal] = useState<boolean>(false);

  const handleModal = useCallback(
    (state: boolean) => {
      setModal(state);
    },
    [setModal]
  );

  const getQuestionState = useCallback(() => {
    return true;
  }, []);
  return (
    <>
      <Container
        key={`report-${type}-${item.id}`}
        active={getQuestionState()}
        onClick={() => handleModal(true)}
      >
        <QuestionGrammr>{item.question}</QuestionGrammr>

        <UserAnwser>
          {(item.answer_submit && item.answer_submit.replace(/,/g, " ")) || ""}
        </UserAnwser>
      </Container>
      {modal && (
        <InterviewModal
          item={item}
          type={type}
          handleModal={handleModal}
          callback={anwserCallback}
        />
      )}
    </>
  );
}

const Container = styled.div<{ active: boolean }>`
  flex-basis: 100%;
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 12px;
  background-color: ${colors.White};
  border: ${(props) =>
    `${props.active ? "1px" : "2px"} solid ${
      props.active ? colors.Gray30 : colors.Error20
    };`};
  box-shadow: 5px 5px 10px ${colors.Gray30};
  margin-right: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const QuestionGrammr = styled.div`
  line-height: 1.5;
  font-size: 24px;
  font-weight: 700;
`;

const UserAnwser = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.Primary50};
  font-weight: 700;
  font-size: 20px;
  margin-top: 20px;
`;

export default InterView;
